/* eslint-disable import/prefer-default-export */
// /* eslint-disable eqeqeq */
// /* eslint-disable brace-style */
// /* eslint-disable linebreak-style */
// /* eslint-disable import/no-extraneous-dependencies */
// import attachEnterAsClick from 'utils/attachEnterAsClick';

import $ from 'jquery';
import scrollTo from 'utils/scroll-to';
import Inputmask from 'inputmask';
import { isValidDropdown, isValidText, isValidEmail, isValidPhone, isValidPostcode, isValidNumber, isValidCcNumber, isValidCvc, isValidBsb, isValidCheckbox, isValidCreditCardName, isValidExpiryDate, isValidAccountName } from '../form-elements/validation';
import initAddressSearch from '../form-elements/google-places';
import paymentProcessingScene from '../../js/utils/payment-processing-scene';

/* eslint no-plusplus: [2, { allowForLoopAfterthoughts: true }] */
/* eslint no-underscore-dangle: 0 */
/* eslint quote-props: ["error", "consistent"] */

window.jQuery = $; // for BED/Kentico script

let currentPaymentType;
let currentDonationAmount;

// helper function is a function that call by other function, not an initial function

/* helper: validate form intro, custom form validation and toggle next buton error
* dont put binding here, it called multiple time
* update ammount message on payment form
*/
const isValidDonation = () => {
    const $form = $('.donation-form-single');
    if ($form.length === 0) return true;

    const minAmount = $form.find('.js-donate').data('min-donate');
    const maxAmount = $form.find('.js-donate').data('max-donate');
    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $donateState = $form.find('.donate-frequency .donate-option, .donate-amounts .donate-option, .donate-amount-input input');
    const $donateAmountField = $form
        .find(`.js-donate .donate-option[data-amount='${$donateAmount.val()}'][data-freq-mode='${$donateFreq.val()}']`);
    const $donateAmountInput = $form.find('.donate-amount-input');
    const $message = $form.find('.donate-msg .donate-message-selected');
    const $errorCon = $form.find('.donate-error');
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const $donateMonthlyFreq = $form.find('.donate-monthly-btn:not(.monthly-text-off)');
    const donateFreqvalue = $donateFreq.val().toLowerCase();
    const donateMonthlyFreqValue = $form.find('.donate-monthly-btn').length ? $form.find('.donate-monthly-btn').data('freq').toLowerCase() : 'no-monthly';
    const $monthlyDisclaimerMessage = $('#RecurringPaymentDisclaimer');
    const $submitButton = $buttonWraper.find('.FormButton');

    let message = '';
    let descMessage = '';
    let errorMessage = '';
    const $messageDesc = $('.js-amount-desc p');

    // clear all selection state and message/error
    $donateState.removeClass('selected');
    $message.parent().removeClass('has-msg');
    $errorCon.removeClass('has-error');
    $buttonWraper.removeClass('Error');

    // freq
    $(`.js-donate .donate-option[data-freq='${$donateFreq.val()}']`).addClass('selected');

    if (donateFreqvalue === donateMonthlyFreqValue) {
        $donateMonthlyFreq.slideUp();
    } else {
        $donateMonthlyFreq.slideDown();
    }

    // if no freq selected, show error
    if ($donateFreq.val() === '') {
        errorMessage = $errorCon.data('error-donation-frequency-not-selected');
    }

    let submitBtnText;

    if (donateFreqvalue === 'recurring') {
        submitBtnText = $submitButton.data('recurring-donation-text');
        $monthlyDisclaimerMessage.removeClass('hidden');
    } else if (donateFreqvalue === 'single') {
        submitBtnText = $submitButton.data('single-donation-text');
        $monthlyDisclaimerMessage.addClass('hidden');
    }

    $submitButton.attr('value', submitBtnText.replace('[amount]', `$${$donateAmount.val()}`));

    // amount
    if ($donateAmount.val() === '') {
        errorMessage = $errorCon.data('error-amount-missing');
    } else if ($donateAmountField.length > 0) {
        $donateAmountField.addClass('selected');
        message = $donateAmountField.data('message');
        descMessage = message;
    } else {
        if ($donateAmount.val() !== '') {
            $form.find('.donate-amount-input input').addClass('selected');
        }

        if (minAmount <= $donateAmount.val() && maxAmount >= $donateAmount.val()) {
            message = '';
            descMessage = $donateAmountInput.data('message');
        } else {
            if ($donateAmount.val() > maxAmount) {
                if (errorMessage !== '') errorMessage += '<br />';
                errorMessage += ($errorCon.data('error-max-amount') + maxAmount);
            }

            if ($donateAmount.val() < minAmount) {
                if (errorMessage !== '') errorMessage += '<br />';
                errorMessage += ($errorCon.data('error-min-amount') + minAmount);
            }
        }
    }

    // emptying message
    $message.html('');
    $messageDesc.html('');

    // render message
    if (message !== '') {
        $message.html(`$${$donateAmount.val()} ${message}`).parent().addClass('has-msg');
    }

    // render descMessage
    if (descMessage !== '') {
        const donationType = $form.find('.js-donate').data(`donation-${$donateFreq.val().toLowerCase()}`);
        $messageDesc.html(`Your ${donationType} of <strong>$${$donateAmount.val()}</strong> ${descMessage}`);
    }

    // render errorMessage
    if (errorMessage !== '') $errorCon.addClass('has-error').html(errorMessage);

    // return true or show error
    if (errorMessage === '') return true;
    $buttonWraper.addClass('Error');
    return false;
};

// helper: personal form field type and validation function
const personalFieldTypes = () => [
    {
        type: 'dropdown',
        tag: 'select',
        func: isValidDropdown
    },
    {
        type: 'text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'email',
        tag: 'input',
        func: isValidEmail
    },
    {
        type: 'phone',
        tag: 'input',
        func: isValidPhone
    },
    {
        type: 'postcode',
        tag: 'input',
        func: isValidPostcode
    },
    {
        type: 'text-other',
        tag: 'input',
        func: isValidText
    }
];

// helper: payment form field type and validation function
const paymentFieldTypes = () => [
    {
        type: 'dropdown',
        tag: 'select',
        func: isValidDropdown
    },
    {
        type: 'text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'cardname',
        tag: 'input',
        func: isValidCreditCardName
    },
    {
        type: 'number',
        tag: 'input',
        func: isValidNumber
    },
    {
        type: 'ccNumber',
        tag: 'input',
        func: isValidCcNumber
    },
    {
        type: 'ccExp',
        tag: 'input',
        func: isValidExpiryDate
    },
    {
        type: 'accountName',
        tag: 'input',
        func: isValidAccountName
    },
    {
        type: 'bsb',
        tag: 'input',
        func: isValidBsb
    },
    {
        type: 'cvc',
        tag: 'input',
        func: isValidCvc
    },
    {
        type: 'checkbox',
        tag: 'input',
        func: isValidCheckbox
    }
];

// helper: payment form field type and validation function
const AddressFieldWithAutocompleteTypes = () => [
    {
        type: 'g-autocomplete-text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'g-autocomplete-dropdown',
        tag: 'select',
        func: isValidDropdown
    },
    {
        type: 'g-autocomplete-postcode',
        tag: 'input',
        func: isValidPostcode
    }
];

/* helper: validate all field in personal/payment detail form
* don't put binding here, it called multiple time
* use only when submit or check whole form, not for validate individual field
* mannualy loop and call each field type validation (import from validation.js)
* toggle next button error
*/
const isValidDetail = (type, fieldTypes, ignoreValidation) => {
    // debug function, set on validateForm();
    if (ignoreValidation === true) {
        /* eslint-disable no-console */
        console.log(`%c Debug mode: %c ${type} validation is ignored\nRemove param true on validateForm() in s-donation-form.js`, 'background: #ccc; color: #ff0000; font-weight: bold', 'background: #ff; color: #333; font-weight: 400');
        return true;
    }

    const $form = $('.donation-form-single');
    if ($form.length === 0) return true;

    let valid = true; // this is the only one who set it true, other will set to false
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const doValidate = (el, func) => {
        if (!func($(el))) valid = false; // make sure it only change to false
    };

    // clear button error
    $buttonWraper.removeClass('Error');

    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function') {
            $form.find(`.jsv-${fieldTypes[i].type} ${fieldTypes[i].tag}:visible`)
                .each((index, element) => doValidate(element, fieldTypes[i].func));
        }
    }

    // return true or show error
    if (valid) return true;

    // Not valid, add error class and scroll up to error field
    $buttonWraper.addClass('Error');
    scrollTo('.js-error', 100);
    return false;
};

/* helper: validate google autocomplete address detail fields
* toggle next button error
*/
const isValidAddressDetailWithAutocomplete = (ignoreValidation = false) => {
    // debug function, set on validateForm();
    if (ignoreValidation === true) {
        /* eslint-disable no-console */
        console.log('%c Debug mode: %c google autocomplete validation is ignored\nRemove param true on validateForm() in s-donation-form.js', 'background: #ccc; color: #ff0000; font-weight: bold', 'background: #ff; color: #333; font-weight: 400');
        return true;
    }

    const $form = $('.donation-form-single');
    if ($form.length === 0) return true;

    let valid = true; // this is the only one who set it true, other will set to false
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    // custom callback to toggle address details after form valildation failed.
    const addressCallback = () => {
        const $switchManualBtn = $('.js-search-address-manually a');
        if ($switchManualBtn.length) {
            $switchManualBtn.click();
        }
    };
    const doValidate = (el, func) => {
        if (!func($(el))) {
            valid = false; // make sure it only change to false
            addressCallback();
        }
    };

    // clear button error
    $buttonWraper.removeClass('Error');
    const fieldTypes = AddressFieldWithAutocompleteTypes();
    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function') {
            $form.find(`.jsv-${fieldTypes[i].type} ${fieldTypes[i].tag}:visible`)
                .each((index, element) => doValidate(element, fieldTypes[i].func));
        }
    }

    const streetNameEl = $form.find('.js-address-street input')[0];
    const streetName = (streetNameEl && streetNameEl.value.length > 0) ? streetNameEl.value : false;
    const postcodeEl = $form.find('.js-address-postcode input')[0];
    const postcode = (postcodeEl && postcodeEl.value) ? postcodeEl.value : false;

    if (!!streetName && !!postcode && streetName.includes(postcode)) {
        valid = false;
        $(streetNameEl).closest('.EditingFormValueCell').addClass('js-error invalid');
        addressCallback();
    }

    // return true or show error
    if (valid) return true;

    // Not valid, add error class and scroll up to error field
    $buttonWraper.addClass('Error');
    scrollTo('.js-error', 100);
    return false;
};

/* helper: validate single input base on type
* validate on change
* validate on keyup if it already error
*/
const validateInputByType = ($form, type, validationFunction, callback) => {
    $form.find(`.jsv-${type} input`)
        .on('change', function () { // on change
            validationFunction($(this), callback);
        })
        .keyup(function () { // on keyup only when it has error
            const $el = $(this);
            if ($el.closest('.EditingFormValueCell.js-error').length > 0) validationFunction($el, callback);
        });
};

// helper: select which form to validate
export const validateForm = () => {
    if (isValidDonation()
        && isValidDetail('personal', personalFieldTypes())
        && isValidAddressDetailWithAutocomplete()
        && isValidDetail('payment', paymentFieldTypes())) {
        return true;
    }
    return false;
};

// avoid kentico onclick button run before validate
const removeKenticoOnclick = () => {
    const $form = $('.donation-form-single');
    const $button = $form.find('.js-form-validate');
    if ($button.length === 0) return;

    if ($button.attr('onclick') !== undefined) {
        $button.addClass('js-click-to-submit');
        $button.removeAttr('onclick');
    }
};

// get processing fee amount based on payment type and amount
const getProcessingFee = () => {
    const $form = $('.donation-form-single');
    const $processingFeeAmount = $form.find('#CheckBoxContro-processing-fee #processing-amount');

    // call api if donation amount and payment type exists
    if (currentDonationAmount && currentPaymentType) {
        const $apiUrl = $form.find('#processing-fee-api').data('api-url');
        const paymentTypeQuery = {
            'paypal-payment': 'PayPal',
            'cc-form': 'CreditCard',
            'debit-form': 'DirectDebit'
        };

        // eslint-disable-next-line max-len
        const $queryUrl = `${$apiUrl}?amount=${currentDonationAmount}&paymenttype=${paymentTypeQuery[currentPaymentType]}`;

        fetch($queryUrl)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Request failed');
            })
            .then(jsonResponse => $processingFeeAmount.html(jsonResponse.data))
            .catch(err => {
                console.log(err);
            });
    }
};

const updateCheckboxLabels = item => {
    const $hiddenPaymentField = $('#hidPaymentType').val();
    if (item === 'Recurring') {
        $('.label-once').addClass('hidden');
        $('.label-processing-fee-once').addClass('hidden');
        $('.label-processing-fee-monthly').removeClass('hidden');
        if ($hiddenPaymentField === 'cc-form') {
            $('.label-monthly-cc').removeClass('hidden');
            $('.label-monthly-dd').addClass('hidden');
            $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our T&C and privacy policy';
        } else {
            $('.label-monthly-dd').removeClass('hidden');
            $('.label-monthly-cc').addClass('hidden');
            $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our Direct Debit Services Agreement';
        }
    }
    if (item === 'Single') {
        $('.label-once').removeClass('hidden');
        $('.label-monthly-cc').addClass('hidden');
        $('.label-monthly-dd').addClass('hidden');
        $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our T&C and privacy policy';
        $('.label-processing-fee-once').removeClass('hidden');
        $('.label-processing-fee-monthly').addClass('hidden');
    }
};

// /* intro form bind
// * update payment form message - donate amount
// */
const initDonationFormUpdateAction = () => {
    const $form = $('.donation-form-single');
    const $donateOptions = $form.find('.donate-frequency .donate-option, .donate-amounts .donate-option, .donate-monthly-btn');
    const $donateCustom = $form.find('.donate-amount-input input');
    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $errorCon = $form.find('.donate-error');
    const $amoutOptions = $form.find('.donate-amounts .donate-option');
    const $preSelectedOptions = $form.find('.donate-amounts .donate-option.selected');
    const $message = $form.find('.donate-msg .donate-message-selected');
    const $iconHolder = $form.find('.donation-icon');
    const $recurringFields = $('#recurring-form');
    const $amountDesc = $form.find('.payment-details .js-amount-desc strong span');

    if ($form.length <= 0) return;

    if ($preSelectedOptions.length) {
        $donateAmount.val($preSelectedOptions.data('amount')).trigger('change');
        $donateCustom.val('');
        // update processing fee API call
        currentDonationAmount = $donateAmount.val();
        getProcessingFee();
    }

    // on donation freg change, show hide message/error, update processing fee API call
    $donateFreq.change(() => {
        const $option = $('.js-card-form-select select');
        isValidDonation();
        currentPaymentType = $option.find(':selected').data('form-id');
        currentDonationAmount = $donateAmount.val();
        getProcessingFee();
    }).change();

    // on donation amount change, show hide message/error, remove session storage, update processing fee API call
    $donateAmount.change(() => {
        isValidDonation();
        currentDonationAmount = $donateAmount.val();
        getProcessingFee();
    }).change();

    // on selection change, update donation
    $donateOptions.click(function (e) {
        e.preventDefault();
        const $el = $(this);

        if ($el.data('freq') !== undefined) {
            $donateFreq.val($el.data('freq')).trigger('change');
            // Show hide the donation amount options for the frequency selected
            $('.donate-amounts .donate-option').hide();
            $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).show();
            if (!$donateCustom.val()) {
                const lastFreqAmount = $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`);
                // No custom donation value, then we set the 2nd donation amount options as selected by default
                if (lastFreqAmount) {
                    $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).filter(`[data-amount="${lastFreqAmount}"]`).click();
                } else {
                    // No last stored frequency amount, so click the 2nd amount by default
                    $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).eq(1).click();
                }
            }

            if ($recurringFields.length) {
                $recurringFields.addClass('not-needed');

                if (window.donationTypes && $el.data('freq') === window.donationTypes.Recurring) {
                    $recurringFields.removeClass('not-needed');
                }
            }
        }

        if ($el.data('amount') !== undefined) {
            $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`, $el.data('amount'));
            $donateAmount.val($el.data('amount')).trigger('change');
            $donateCustom.val('');

            // On amount selection, we also change the displaying icon
            if ($iconHolder.length && $el.find('.amount-icon').length) {
                $iconHolder.html($el.find('.amount-icon').html());
            }
        }

        // update ammount on payment form
        if ($amountDesc.length > 0) {
            $amountDesc.text($el.data('amount'));
        }

        updateCheckboxLabels($el.data('freq'));
    });

    // on keyup in custom donation, update donation
    $donateCustom.keyup(function () {
        $donateAmount.val($(this).val());

        // trigger change if error visible
        if ($errorCon.hasClass('has-error')) $donateAmount.trigger('change');

        // Check if we have a valid value in the input, if so, unselect the other options
        if ($(this).val()) {
            $amoutOptions.removeClass('selected');
            $message.html('').parent().removeClass('has-msg');
        }
    });

    // on keyup in custom donation, update donation
    $donateCustom.change(function () {
        $donateAmount.val($(this).val()).trigger('change');
    });
};

// detail form field bind and validation
const initDetailFormUpdateAction = (type, fieldTypes) => {
    const $form = $('.donation-form-single');
    if ($form.length === 0) return;

    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const excludeLoopText = ['dropdown'];
    const toggleButtonError = respon => {
        $buttonWraper.addClass('Error');

        if (respon) {
            if ($form.find(`.${type}-details .js-error`).length === 0) $buttonWraper.removeClass('Error');
        }
    };

    // validate single dropdown on change
    $form.find('.jsv-dropdown select').change(function () {
        isValidDropdown($(this), null, toggleButtonError);
    });
    // dropdown in google autocomplete template use this class.
    $form.find('.jsv-g-autocomplete-dropdown select').change(function () {
        isValidDropdown($(this), null, toggleButtonError);
    });

    // validate input-* [text, phone, number, postcode, cvc, checkbox]
    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function' && excludeLoopText.indexOf(fieldTypes[i].type) < 0) {
            validateInputByType($form, fieldTypes[i].type, fieldTypes[i].func, toggleButtonError);
        }
    }
};

// input form field mask
const inputMaskInit = el => {
    // Lets first mask account number if its here
    // @NOTE - here we assume only the account number under debit-form has the jsv-number class
    const $accountNumberInput = $('#debit-form .jsv-number input');
    if ($accountNumberInput.length) {
        Inputmask({
            mask: '999999999',
            placeholder: '',
            showMaskOnFocus: false
        }).mask($accountNumberInput);
    }

    // The rest is masking CC and BSB field
    const ccNumberSelector = 'jsv-ccNumber';
    const bsbNumberSelector = 'jsv-bsb';

    // make sure it run on donation page only
    if ($(`.${ccNumberSelector}`).length === 0) return;

    const $inputMaskCC = $(`.${ccNumberSelector} input`);
    const $inputMaskBSB = $(`.${bsbNumberSelector} input`);
    // const dinersTxt = window.cardTypes !== undefined ? window.cardTypes.Diners : 'Diners';
    const amexTxt = window.cardTypes !== undefined ? window.cardTypes.Amex : 'Amex';
    const $ccNumberError = $($inputMaskCC).parents(`.${ccNumberSelector}`).find('.js-error');

    if (!$inputMaskCC.length && !$inputMaskBSB.length) { return; }

    // resetting error message (if any)
    if ($ccNumberError.length > 0) {
        $ccNumberError.removeClass('js-error invalid');
    }
    if (document.getElementsByClassName('js-reduced-fields').length === 0) {
        $($inputMaskCC).val('');
    } else { // This part is for the reduced cc payment fields form
        const inputMaskccExpDate = document.getElementsByClassName('jsv-ccExp')[0].getElementsByTagName('input');
        const applyExpDateMask = () => {
            Inputmask({
                mask: '99/99',
                placeholder: 'MM/YY',
                showMaskOnFocus: false
            }).mask(inputMaskccExpDate);
        };
        applyExpDateMask();
        // if browser autofills exp date
        document.addEventListener('keydown', e => {
            if (typeof e.key === 'undefined') {
                Inputmask.remove(inputMaskccExpDate);
            }
        });
        // re-apply inputmask after browser has autofilled exp date
        document.addEventListener('keyup', e => {
            if (typeof e.key === 'undefined') {
                applyExpDateMask();
            }
        });
    }// End of the reduced cc payment fields form

    // need to destroy Inputmask on IOS 9
    Inputmask.remove($inputMaskCC);

    const applyCCMasks = () => {
        // if ($(el).val() === dinersTxt) {
        //     Inputmask({
        //         mask: '9999 999999 9999 99',
        //         placeholder: '',
        //         showMaskOnFocus: false
        //     }).mask($inputMaskCC);
        // } else
        if ($(el).val() === amexTxt) {
            Inputmask({
                mask: '9999 999999 99999',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputMaskCC);
        } else {
            Inputmask({
                mask: '9999 9999 9999 9999',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputMaskCC);
        }
    };

    applyCCMasks();

    Inputmask({
        mask: '999-999',
        placeholder: '',
        showMaskOnFocus: false
    }).mask($inputMaskBSB);

    // remove and reapply mask whilst autofill complete CC details
    $(document).on('keydown', e => {
        // Undefined key on "keydown" means autofill is being used.
        if (typeof e.keyCode === 'undefined') {
            Inputmask.remove($inputMaskCC);
        }
    });
    $(document).on('keyup', e => {
        // Re-initialise inputmask after autofill has done it's job
        if (typeof e.keyCode === 'undefined') {
            applyCCMasks();
        }
    });
};

const getPaymentType = () => {
    const $option = $('.js-card-form-select .payment-type select');
    const currType = $option.find(':selected').data('form-id');
    return currType;
};


// Common function to handle submit button click on the donate form - it is used on normal
// js-form-validate button and also any button with recaptcha enabled
// Function made global so it can be used by the google recaptcha callback
window.handleDonateSingleButtonClick = $button => {
    const $form = $('.donation-form-single');

    console.log('$form', $form);

    if ($form.length === 0) return;

    if ($button.hasClass('js-click-to-submit')) {
        if (!$button.attr('disabled')) {
            $button.attr('disabled', true);
            $button.removeClass('js-click-to-submit');
            paymentProcessingScene();
            window.__doPostBack($button.attr('name'), 'Click');
        }
    }
};

// init on submit next button - only the ones without recaptcha enabled
const initSubmitButton = () => {
    const $form = $('.donation-form-single');
    const $submit = $form.find('.js-form-validate').not('.with-recaptcha');
    if ($submit.length === 0) return;

    $submit.click(e => {
        e.preventDefault();
        replaceRightQuotation();
        const $button = $(e.target);
        const currPayType = getPaymentType();
        if (validateForm() && currPayType !== 'cc-form') {
            window.handleDonateSingleButtonClick($button);
        }
    });
};

// init on submit next button - the ones with recaptcha enabled
const initSubmitButtonWithRecaptcha = () => {
    const $form = $('.donation-form-single');
    const $submit = $form.find('.js-form-validate.with-recaptcha');
    if ($submit.length === 0) return;

    $submit.click(e => {
        e.preventDefault();
        replaceRightQuotation();
        const $button = $(e.target);
        const currPayType = getPaymentType();

        if (validateForm() && currPayType !== 'cc-form') {
            const $hiddenToken = $button.siblings('.g-recaptcha-response');
            console.log('valid');
            // we trigger the google recaptcha call for anti-bot measure
            // Only trigger the re-captcha if we havent got the google check token
            if ($hiddenToken.length && $hiddenToken.val()) {
                console.log($hiddenToken.val());
                window.submitRecaptchaSingleForm($hiddenToken.val());
            } else {
                window.grecaptcha.execute();
            }
        }
    });
};

// This global function will be called by Google Recaptcha once the recaptcha validation is done on the client side
window.submitRecaptchaSingleForm = token => {
    const $button = $('.js-form-validate.with-recaptcha');
    const $hiddenToken = $button.siblings('.g-recaptcha-response');
    $hiddenToken.val(token);

    window.handleDonateSingleButtonClick($button);
};

// select payment method
const donateSelectCardForm = () => {
    const $option = $('.js-card-form-select select');
    const $hiddenPaymentField = $('#hidPaymentType');
    const ccType = '.cc-type';

    if ($option.length === 0) return;

    $('.js-card-form-option-item').addClass('hide');

    const setSelectedCardForm = () => {
        // update processing fee API call
        currentPaymentType = $option.find(':selected').data('form-id');
        $hiddenPaymentField.val(currentPaymentType);
        const $donateFreq = $('.donate-hidden-freq').val();
        updateCheckboxLabels($donateFreq);
        getProcessingFee();
        $(`#${$option.find(':selected').data('form-id')}`).removeClass('hide').siblings('.js-card-form-option-item').addClass('hide');
    };

    $option.change(e => {
        setSelectedCardForm();

        if ($(e.target).parents(`${ccType}`).length) {
            inputMaskInit($(e.target));
        }
    });

    setSelectedCardForm();
};

// This part is for the reduced cc payment fields form
// EventListener to detect cc type when a user enters/paste/ browser autofills cc number and then apply inputmask according to the cc type
if (document.getElementsByClassName('js-reduced-fields').length) {
    document.getElementsByClassName('jsv-ccNumber')[0].addEventListener('input', detectCreditCardType);
}
function detectCreditCardType() {
    const hiddenCCType = document.getElementsByClassName('hidden-cc-type')[0];
    const numberWrap = document.getElementsByClassName('jsv-ccNumber')[0];
    if (hiddenCCType && numberWrap) {
        const number = numberWrap.getElementsByTagName('input').item(0).value;
        const numberLength = number.length;

        // These Regexs are also listed in validation.js file inside of isValidCcNumber
        const visaRegEx = /^(?:4[0-9]{3})\s?([\d]{4})\s?([\d]{4})\s?([\d]{4})$/;
        const mastercardRegEx = /^(?:5[0-5]|2[2-7])(?:[\d]{2})\s?([\d]{4})\s?([\d]{4})\s?([\d]{4})$/;
        const amexpRegEx = /^(?:3[47])(?:[\d]{2})\s?([\d]{6})\s?([\d]{5})$/;
        // const dinerIntRegEx = /^(?:3[0689])(?:[\d]{2})\s?([\d]{6})\s?([\d]{4})\s?$/;
        // const dinerCarteRegEx = /^(?:3[0])(?:[0-5])(?:[\d]{1})\s?([\d]{6})\s?([\d]{4})\s?$/;

        if (number === '') {
            hiddenCCType.value = '';
            inputMaskInit(hiddenCCType);
        } else if (number.match(RegExp(visaRegEx)) != null) {
            hiddenCCType.value = 'Visa';
            inputMaskInit(hiddenCCType);
        } else if (number.match(RegExp(mastercardRegEx))) {
            hiddenCCType.value = 'MasterCard';
            inputMaskInit(hiddenCCType);
        } else if ((number.match(RegExp(amexpRegEx)) != null) || ((number.match(RegExp('^3[47]')) != null) && (numberLength === 17 || numberLength === 18))) {
            // If len 17: val is typed, len 18: val is pasted. If number matches amexpRegEx: val is autofilled
            hiddenCCType.value = 'Amex';
            inputMaskInit(hiddenCCType);
            // }
            // // if len 17: val is typed or pasted. If number matches regex: val is autofilled.
            // else if ((number.match(RegExp(dinerIntRegEx)) != null) || (number.match(RegExp(dinerCarteRegEx)) != null) || ((number.match(RegExp('^3[0689]|30[0-5]')) != null) && (numberLength == 17))) {
            //     hiddenCCType.value = 'Diners';
            //     inputMaskInit(hiddenCCType);
        } else {
            hiddenCCType.value = 'invalid';
        }
    }
}

// EventListener to store CC Expiry date into hidden fields
if (document.getElementsByClassName('js-reduced-fields').length) {
    document.getElementsByClassName('jsv-ccExp')[0].addEventListener('input', formatExpiryDate);
}
function formatExpiryDate() {
    const hiddenccExpMonth = document.getElementsByClassName('hidden-cc-expiry-month')[0];
    const hiddenccExpYear = document.getElementsByClassName('hidden-cc-expiry-year')[0];
    const ccExpiryDateWrapper = document.getElementsByClassName('jsv-ccExp')[0];

    if (hiddenccExpMonth && hiddenccExpYear && ccExpiryDateWrapper) {
        const ccExpiryDate = ccExpiryDateWrapper.getElementsByTagName('input').item(0).value;
        /* substring(0,2) gives the first two digit of user input value (month)
            substring(3,5) gives the last two digit of user input value (year) */
        hiddenccExpMonth.value = ccExpiryDate.substring(0, 2);
        hiddenccExpYear.value = ccExpiryDate.substring(3, 5);
    }
}

// End of the reduced cc payment fields form

// replace the right quotation mark with apostrophe
function replaceRightQuotation() {
    const $testFields = $('.donation-form-single input[type=text]');

    $testFields.each(function () {
        if ($(this).val().includes('’')) {
            $(this).val($(this).val().replaceAll('’', "'"));
        }
    });
}

// allow input type number to have maxlength
const initMaxLengthNumber = () => {
    const $numberInput = $('.donation-form-single input[type=number]');
    if (!$numberInput.length) { return; }

    $numberInput.keypress(e => {
        const $el = $(e.target);
        const max = $el.attr('maxlength');
        if (max === undefined || max === '') return true;
        if ($el.val().length >= max) return false;
        return true;
    });
};

// validate input to allow number only on keypress, include money (disallow leading zero)
const initNumberOnlyInput = () => {
    const regex = /^\d*\.?\d{0,2}$/;
    const $numberInput = $('.donation-form-single input[type=number]');
    let oldVal = '';

    if (!$numberInput.length) { return; }

    $numberInput.keypress(e => {
        const $el = $(e.target);
        const event = e || window.event;
        const charCode = (typeof event.which === 'undefined') ? event.keyCode : event.which;
        const charStr = String.fromCharCode(charCode);
        const val = $el.val().toLowerCase() + charStr.toLowerCase();

        // test digit
        if (regex.test(val)) {
            // test for money format, for intro form only
            if ($el.closest('.donate-amount-input').length > 0) {
                if (val.startsWith('0')) return false;
            }

            return true;
        }

        return false;
    });

    // for money (intro form only)
    $numberInput.keyup(e => {
        const $el = $(e.target);
        const newVal = $el.val();

        if ($el.closest('.donate-amount-input').length > 0) {
            if (newVal.startsWith('0')) {
                $el.val(oldVal);
                return;
            }

            oldVal = newVal;
        }
    });
};

const initDonationForm = () => {
    const $form = $('.donation-form-single');
    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $('.donate-hidden-amount');
    const $recurringFields = $('#recurring-form');
    const $lastDonateAmount = $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`);

    const donateValue = $lastDonateAmount ? $lastDonateAmount : $donateAmount.val();

    const $donateAmountField = $(`.donate-option[data-amount='${donateValue}']`);

    if ($donateFreq.length <= 0) return;

    if ($donateFreq.val() === 'Recurring') {
        $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our Direct Debit Services Agreement';
    }
    if ($donateFreq.val() === 'Single') {
        $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our T&C and privacy policy';
    }

    // window.globalHelper.orderSessionManager.init();
    window.globalHelper.orderSessionManager.setAppealDonationValues();

    $(`.donate-option[data-freq='${$donateFreq.val()}']`).addClass('selected');
    $('.donate-amounts .donate-option').hide();
    $(`.donate-amounts .donate-option[data-freq-mode='${$donateFreq.val()}']`).show();

    if ($donateAmountField.length > 0) {
        $donateAmountField.addClass('selected');
    } else {
        $('.donate-amount-input input').val(donateValue).addClass('selected');
    }

    if (window.donationTypes && $donateFreq.val() === window.donationTypes.Recurring) {
        $recurringFields.removeClass('not-needed');
    }
};

const initSingleForm = () => {
    const $singleForm = $('.donation-form-single');

    if (!$singleForm.length) { return; }

    initDonationForm();
};

const initIcon = () => {
    const $donationIcon = $('.donation-icon');

    if (!$donationIcon.length) { return; }

    const $selectedDonation = $('.donate-option.selected');
    const selectedIcon = $selectedDonation.find('.amount-icon').html();
    const $clonedImage = $(selectedIcon).clone();

    $donationIcon.html('').append($clonedImage);
};

const initSessionStorage = () => {
    const dAmt = sessionStorage.getItem('dAmt');
    const dType = sessionStorage.getItem('dType');

    const $form = $('.donation-form-single');
    const $donateCustom = $('.s-donation-form-single .donate-amount-input input');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $donateFreq = $form.find('.donate-hidden-freq');

    if (dType) {
        // eslint-disable-next-line
        const newFreq = Base64.decode(dType)

        const $donateFreqOption = $(`.donate-option[data-freq="${newFreq}"]`);
        $donateFreq.val(newFreq);
        $donateFreqOption.click();
    } else if ($form.find('.donate-frequency').length > 0) {
        $(`.donate-option[data-freq="${$donateFreq.val()}"]`).click();
    }

    if (dAmt) {
        // eslint-disable-next-line
        const $donateAmountField = $form.find(`.js-donate .donate-option[data-amount='${Base64.decode(dAmt)}'][data-freq-mode=${$donateFreq.val()}]`);
        const $donateFreqSingle = $('.donate-option[data-freq="Single"]');

        // eslint-disable-next-line
        $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`, Base64.decode(dAmt));
        if ($donateAmountField.length > 0) {
            // if donation freq is not on session storage, select single donation by default
            if (!dType && !($donateFreqSingle.length)) {
                $donateFreqSingle.click();
            }

            // eslint-disable-next-line
            $donateAmount.val(Base64.decode(dAmt)).change();
        } else {
            if ($donateCustom.length === 0) return;

            // eslint-disable-next-line
            $donateCustom.val(Base64.decode(dAmt)).change();
        }
    }

    sessionStorage.removeItem('dAmt');
    sessionStorage.removeItem('dType');
};

const checkUtm = () => {
    const currentUrl = window.location.toString();

    if (!currentUrl.match(/(?:utm_source|utm_campaign|utm_medium)/i)) {
        const hiddenInput = document.querySelector('input[type=hidden].referrer-url');

        if (hiddenInput) {
            hiddenInput.value = document.referrer;
        }
    }
};

$(() => {
    removeKenticoOnclick();
    // keep above first, it has mapping and collection init

    initSingleForm(); // open requested/error form
    initDonationFormUpdateAction(); // on change, click, keyup etc
    initDetailFormUpdateAction('personal', personalFieldTypes()); // on change, click, keyup etc
    initDetailFormUpdateAction('payment', paymentFieldTypes()); // on change, click, keyup etc
    initDetailFormUpdateAction('g-autocomplete', AddressFieldWithAutocompleteTypes()); // on change, click, keyup etc
    initSubmitButton();
    initSubmitButtonWithRecaptcha();
    initMaxLengthNumber();
    initNumberOnlyInput();
    donateSelectCardForm();
    inputMaskInit();
    initIcon();
    initAddressSearch();
    initSessionStorage();
    checkUtm();
});




// WEBPACK FOOTER //
// ./src/components/donation-form-single/c-donation-form-single.js